import { ReactNode } from 'react';
import { Badge, BadgeColor } from '@givebutter/primitives/badge';
import { faPaperPlane } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EngageMessageStatus } from 'types/domain';

interface LetterStatusBadgeProps {
    status: EngageMessageStatus;
}

const LetterStatusBadge = (props: LetterStatusBadgeProps) => {
    const { status } = props;
    const statusBadgeProps: { text: string; color: BadgeColor; icon: ReactNode } = {
        text: 'Draft',
        icon: null,
        color: 'neutral',
    };

    switch (status) {
        case 'sent':
            statusBadgeProps.text = 'Sent';
            statusBadgeProps.color = 'success';
            statusBadgeProps.icon = <FontAwesomeIcon size={'sm'} icon={faPaperPlane} />;
            break;
        case 'preparing':
        case 'queued':
            statusBadgeProps.text = 'Generating';
            statusBadgeProps.color = 'warning';
            break;
        case 'sending':
            statusBadgeProps.text = 'Ready to print';
            statusBadgeProps.color = 'primary';
            break;
        case 'failed':
            statusBadgeProps.text = 'Failed';
            statusBadgeProps.color = 'error';
            break;
    }

    return (
        <Badge color={statusBadgeProps.color}>
            {statusBadgeProps.icon}
            <p className={'text-xs leading-none'}>{statusBadgeProps.text}</p>
        </Badge>
    );
};

export { LetterStatusBadge };
